import "../../styles/form.css"
const CustomForm = ({children, ...props})=>{
    return <form className={`form ${props.className}`} {...props} >
        {children}
    </form>
}
export default CustomForm